import { SEO } from "@/components/SEO";
import React from "react";
import { Link } from "react-router-dom";
import { Gift, Package, MessageCircle, Users, ArrowRight } from "lucide-react";

export default function Regala() {
  return (
    <div>
      <SEO title="Regala una experiencia · Utopistas" description="Hay regalos que se abren y otros que se viven. Regala a un adulto mayor una experiencia Utopistas: conversación, comunidad y aprendizaje." />
      <section className="bg-gradient-to-b from-cometa-dorado/25 to-cometa-crema py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="font-script text-4xl md:text-5xl text-cometa-carmesi mb-3">Regala la experiencia.</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl leading-[0.95] mb-8">Hay regalos que se abren. <em className="text-cometa-marino">Otros se viven.</em></h1>
          <p className="text-xl md:text-2xl text-cometa-tinta/80 leading-relaxed max-w-3xl mx-auto mb-10">
            ¿Qué le regalas a alguien que ya tiene todo lo que necesita, pero quizás no tiene con quién compartir una buena conversación esta semana?
          </p>
          <Link to="/marca/experiencias" data-testid="regala-cta-1" className="btn inline-flex items-center gap-3 bg-cometa-marino text-cometa-crema px-10 py-5 text-lg rounded-full font-semibold hover:bg-cometa-tinta transition">
            Quiero regalar la experiencia <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-16 md:py-24">
        <h2 className="text-4xl md:text-5xl mb-6">Regálale un mes de comunidad.</h2>
        <p className="text-xl text-cometa-tinta/80 leading-relaxed mb-14 max-w-3xl">
          Tertulias, círculos de lectura, clases de idiomas, salidas al teatro y charlas de bienestar pensadas para que siga descubriendo, conectando y sintiéndose parte de algo — acompañado de una Caja Experiencia que llega directo a su puerta.
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          {[
            { i: Package, t: "Un libro por descubrir", d: "Elegido con cuidado. Llega en la Caja Experiencia." },
            { i: MessageCircle, t: "Conversaciones por compartir", d: "Cuatro sesiones en línea, más un encuentro presencial en CDMX." },
            { i: Gift, t: "Una caja llena de sorpresas", d: "El libro te lo contamos. Lo demás es sorpresa." },
            { i: Users, t: "Nuevas personas por conocer", d: "Una comunidad pequeña y constante." },
          ].map(({ i: Icon, t, d }) => (
            <div key={t} className="bg-white border border-cometa-marino/10 rounded-3xl p-8">
              <Icon size={28} className="text-cometa-carmesi mb-4" />
              <h3 className="text-2xl mb-2">{t}</h3>
              <p className="text-lg text-cometa-tinta/80">{d}</p>
            </div>
          ))}
        </div>
        <p className="mt-14 text-2xl text-center font-display italic text-cometa-marino max-w-3xl mx-auto">No es solo llenar su tiempo. Es recordarle que su curiosidad, su voz y sus ganas de seguir aprendiendo siguen teniendo un lugar.</p>
      </section>
    </div>
  );
}
